import React, { Component } from 'react';
import './Sidebar.css';
import SidebarBlockChart from './SidebarBlockChart';
import SidebarDistrictChart from './SidebarDistrictChart';

class Sidebar extends Component {

  render() {

    return (
			<div>
				{this.props.blockChartShow===false &&	<SidebarDistrictChart buildingCategory={this.props.buildingCategory} onBuildingCategoryChange = {this.props.onbuildingCategoryChange} />}
				{this.props.blockChartShow===true && <SidebarBlockChart blockDetails={this.props.blockDetails} zoomOut={this.props.zoomOut} />}
			</div>
    );
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/Sidebar.js